import React, { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import styles from "./Header.module.scss";
import { additionlInfoModalActions } from "@/entities/additionInfoModal";
import mixpanel from "@/shared/lib/mixpanel";
import { useMe, useCurrentOrganization } from "@/Hooks";
import { formatNumber } from "@/shared/lib/constants/formaters";
import VersionsMenu from "./VersionsMenu";

interface HeaderProps {
  data: {
    icon: string;
    name: string;
    shortname: string;
    slug?: string;
    revenue?: number;
    downloads?: number;
  };
  appId: number;
}

const Header: React.FC<HeaderProps> = ({ data, appId }) => {
  const dispatch = useDispatch();
  const { me } = useMe();
  const currentOrganization = useCurrentOrganization();

  const iconTimerSaveAppRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const iconTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hideTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (iconTimerSaveAppRef.current)
        clearTimeout(iconTimerSaveAppRef.current);
      if (iconTimerRef.current) clearTimeout(iconTimerRef.current);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
  }, []);

  const handleExpand = () => {
    mixpanel.track("Info clicked", {
      app_name: "App",
      idApp: appId,
      UserEmail: me?.email || "",
      OrganizationID: currentOrganization?.uuid || "",
    });
    dispatch(additionlInfoModalActions.toggleItem());
  };

  return (
    <div className={styles.root}>
      <div className={styles.containerLeft}>
        <div className={styles.containerTop}>
          <div className={styles.containerTitleWrapper}>
       
            <div className={styles.containerTitle}>
              <img
                className={styles.logo}
                src={
                  data!.icon === "" || !data!.icon
                    ? "/img/skeletonLogo.svg"
                    : data!.icon
                }
                alt={`${data!.name} logo icon`}
                loading="lazy"
                draggable={false}
              />
              <div className={styles.titleExpandable}>
                <div className={styles.title}>
                  <h1 title={data!.name}>{data!.name}</h1>
                  <p title={data!.shortname}>{data!.shortname}</p>
                </div>
              </div>
            </div>
            <div className={styles.containerTitleStats}>
              <div className={styles.containerTitleStatsItem}>
                <span>Revenue / mo</span>
                <p>
                  $
                  {data?.revenue === 0 || (data?.revenue && data.revenue < 5000)
                    ? "<5k"
                    : formatNumber(data?.revenue || 0)}
                </p>
              </div>
              <div className={styles.containerTitleStatsItem}>
                <span>Installs / mo</span>
                <p>
                  {data?.downloads === 0 ||
                  (data?.downloads && data.downloads < 5000)
                    ? "<5k"
                    : formatNumber(data?.downloads || 0)}
                  +
                </p>
              </div>
              <button onClick={handleExpand} className={styles.moreInfoButton}>
                <p>More Info</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
